import { render, staticRenderFns } from "./ExaminationDetailsModal.vue?vue&type=template&id=00cc730c"
import script from "./ExaminationDetailsModal.vue?vue&type=script&lang=js"
export * from "./ExaminationDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports